/**
 * ViewContent Webhook for International Markets
 * 
 * Sends ViewContent event to n8n when product pages load
 */

(function() {
  'use strict';
  
  // Check if helper is available
  if (!window.WebhookHelper || !window.WebhookHelper.isInternationalMarket()) {
    return;
  }
  
  // Check if product page
  if (!window.location.pathname.includes('/products/')) {
    return;
  }
  
  let viewContentFired = false;
  
  // Extract product ID
  function extractProductId() {
    // Method 1: Shopify analytics
    if (window.Shopify && window.Shopify.analytics && 
        window.Shopify.analytics.meta && window.Shopify.analytics.meta.product) {
      return window.Shopify.analytics.meta.product.id || 
             window.Shopify.analytics.meta.product.product_id;
    }
    
    // Method 2: Product JSON
    const productJson = document.querySelector('script[data-product-json]');
    if (productJson) {
      try {
        const data = JSON.parse(productJson.textContent);
        return data.id;
      } catch (e) {
        // Ignore
      }
    }
    
    return null;
  }
  
  // Extract variant ID
  function extractVariantId() {
    // Method 1: URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    if (variantParam) {
      return variantParam;
    }
    
    // Method 2: Product JSON
    const productJson = document.querySelector('script[data-product-json]');
    if (productJson) {
      try {
        const data = JSON.parse(productJson.textContent);
        if (data.variants && data.variants.length > 0) {
          const firstAvailable = data.variants.find(v => v.available) || data.variants[0];
          return firstAvailable.id.toString();
        }
      } catch (e) {
        // Ignore
      }
    }
    
    return null;
  }
  
  // Extract price (in INR cents)
  function extractPrice() {
    // Method 1: Shopify analytics
    if (window.Shopify && window.Shopify.analytics && 
        window.Shopify.analytics.meta && window.Shopify.analytics.meta.product) {
      const price = window.Shopify.analytics.meta.product.price || 
                   window.Shopify.analytics.meta.product.final_price;
      if (price && price > 0) {
        return parseInt(price, 10);
      }
    }
    
    // Method 2: Product JSON
    const productJson = document.querySelector('script[data-product-json]');
    if (productJson) {
      try {
        const data = JSON.parse(productJson.textContent);
        if (data.variants && data.variants.length > 0) {
          const urlParams = new URLSearchParams(window.location.search);
          const variantParam = urlParams.get('variant');
          
          let selectedVariant = null;
          if (variantParam) {
            selectedVariant = data.variants.find(v => 
              v.id.toString() === variantParam || v.id === parseInt(variantParam)
            );
          }
          
          if (!selectedVariant) {
            selectedVariant = data.variants.find(v => v.available) || data.variants[0];
          }
          
          if (selectedVariant && selectedVariant.price) {
            return parseInt(selectedVariant.price, 10);
          }
        }
      } catch (e) {
        // Ignore
      }
    }
    
    return null;
  }
  
  // Extract product name
  function extractProductName() {
    return document.querySelector('h1.product__title')?.textContent?.trim() ||
           document.querySelector('h1')?.textContent?.trim() ||
           '';
  }
  
  // Wait for product data (optimized polling)
  function waitForProductData(callback) {
    let attempts = 0;
    const maxAttempts = 20; // Reduced from 30 to 20 (2 seconds max)
    
    // Try immediate check first (most common case)
    const hasAnalytics = window.Shopify && 
                        window.Shopify.analytics && 
                        window.Shopify.analytics.meta && 
                        window.Shopify.analytics.meta.product;
    
    const hasProductJson = document.querySelector('script[data-product-json]');
    
    if (hasAnalytics || hasProductJson) {
      callback();
      return; // Early exit - no polling needed
    }
    
    // Only poll if data not immediately available
    function check() {
      attempts++;
      
      const hasAnalytics = window.Shopify && 
                          window.Shopify.analytics && 
                          window.Shopify.analytics.meta && 
                          window.Shopify.analytics.meta.product;
      
      const hasProductJson = document.querySelector('script[data-product-json]');
      
      if (hasAnalytics || hasProductJson || attempts >= maxAttempts) {
        callback();
        return;
      }
      
      // Use longer interval (200ms instead of 100ms) to reduce CPU usage
      setTimeout(check, 200);
    }
    
    check();
  }
  
  // Send ViewContent webhook
  function sendViewContentWebhook() {
    if (viewContentFired) return;
    
    const productId = extractProductId();
    const variantId = extractVariantId();
    const priceInCents = extractPrice();
    const productName = extractProductName();
    const marketConfig = window.WebhookHelper.getMarketConfig();
    
    if (!variantId && !productId) {
      // Retry after delay if data not available
      setTimeout(sendViewContentWebhook, 1000);
      return;
    }
    
    if (!priceInCents || priceInCents <= 0) {
      // Retry after delay if price not available
      setTimeout(sendViewContentWebhook, 1000);
      return;
    }
    
    const contentId = variantId || productId;
    const prefixedIds = window.WebhookHelper.prefixContentIds([contentId.toString()]);
    const priceInMarketCurrency = window.WebhookHelper.roundUpPrice(
      window.WebhookHelper.convertToMarketCurrency(priceInCents)
    );
    
    window.WebhookHelper.sendWebhook('ViewContent', {
      custom_data: {
        content_type: 'product',
        content_ids: prefixedIds,
        content_name: productName,
        value: priceInMarketCurrency,
        currency: marketConfig.currency,
        market: marketConfig.market,
        catalog_prefix: marketConfig.catalogPrefix,
        locale: marketConfig.locale,
        contents: [{
          id: prefixedIds[0],
          sku: prefixedIds[0],
          item_price: priceInMarketCurrency,
          quantity: 1,
          currency: marketConfig.currency
        }]
      },
      product_data: {
        product_id: productId,
        variant_id: variantId,
        product_title: productName,
        price_in_cents: priceInCents,
        price_converted: priceInMarketCurrency
      }
    });
    
    viewContentFired = true;
  }
  
  // Wait for product data, then fire
  waitForProductData(function() {
    sendViewContentWebhook();
    
    // Retry once after 1 second if not fired
    setTimeout(function() {
      if (!viewContentFired) {
        sendViewContentWebhook();
      }
    }, 1000);
  });
  
})();

